'use client';

import useSWR from 'swr';

import { TypeProduct } from '@/core/generated-types';

import {
  ContentfulPreviewData,
  getProductByPlaygeniusProductAnchor,
} from './contentful';

export const useGetProductByPlaygeniusProductAnchor = (
  playgeniusProductAnchor: string,
  locale?: string,
  isPreview?: boolean,
  previewData?: ContentfulPreviewData,
) => {
  const { data } = useSWR<TypeProduct, Error>(
    `getProductByPlaygeniusProductAnchor_${playgeniusProductAnchor}_${locale}`,
    () =>
      getProductByPlaygeniusProductAnchor(
        playgeniusProductAnchor,
        locale,
        isPreview,
        previewData,
      ),
  );

  return data;
};
